import { render, staticRenderFns } from "./botIframe.vue?vue&type=template&id=7b7cef02&scoped=true"
import script from "./botIframe.vue?vue&type=script&lang=js"
export * from "./botIframe.vue?vue&type=script&lang=js"
import style0 from "./botIframe.vue?vue&type=style&index=0&id=7b7cef02&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7cef02",
  null
  
)

export default component.exports